module.exports = __webpack_public_path__ + "img/picto-data-provider.996441c5.svg";